module.exports = __webpack_public_path__ + "c54f002108f1f01f3d88446709a956a7.svg";